import React from "react";

// Default rows
export const defaultMortgageResolutionRows = [
  { item: "Modification", number: "", loanValue: "" },
  { item: "Foreclosure", number: "", loanValue: "" },
  { item: "Short sale/deed in lieu", number: "", loanValue: "" },
];

const MortgageResolutionTable = ({ resolutionTable, setResolutionTable }) => {
  // Fallback to defaults; only write to state on change
  const safeTableData =
    Array.isArray(resolutionTable) && resolutionTable.length
      ? resolutionTable
      : defaultMortgageResolutionRows;

  const handleInputChange = (rowIndex, field, value) => {
    const updated = [...safeTableData];
    updated[rowIndex][field] = value;
    setResolutionTable(updated);
  };

  return (
    <div
      style={{
        marginTop: "16px",
        overflowX: "auto",
        border: "0.6px solid #999",
        borderRadius: "12px",
        overflow: "hidden",
        width: "100%",
        maxWidth: "none",
        marginInline: "auto",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th
              style={{
                ...tableHeaderStyle,
                textAlign: "left",
                paddingLeft: "16px",
              }}
            ></th>
            <th style={tableHeaderStyle}>Number</th>
            <th style={tableHeaderStyle}>Loan value</th>
          </tr>
        </thead>

        <tbody>
          {safeTableData.map((row, index) => (
            <tr key={index}>
              <td
                style={{
                  ...tableCellStyle,
                  textAlign: "left",
                  fontWeight: "600",
                  paddingLeft: "16px",
                  backgroundColor: "#D3C9CE",
                  whiteSpace: "normal",
                }}
              >
                {row.item}
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  value={row.number}
                  onChange={(e) =>
                    handleInputChange(index, "number", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  step="any"
                  value={row.loanValue}
                  onChange={(e) =>
                    handleInputChange(index, "loanValue", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles (same as your reference)
const tableHeaderStyle = {
  padding: "20px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  lineHeight: 1.25,
};

const tableCellStyle = {
  padding: "14px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  lineHeight: 1.25,
};

const inputStyle = {
  width: "95%",
  padding: "14px",
  height: "40px",
  borderRadius: "8px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default MortgageResolutionTable;
